import React from 'react';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { DropdownItem } from 'src/componentes/dropdown';
import Tooltip from 'src/componentes/tooltip';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import ModalPlanejamentoInicial from 'src/paginas/PlanejamentoInicial/view-modal';
import { DownloadFile, ParseError } from 'src/services/downloadFileUrl';
import ContentManager from 'src/componentes/content-manager';
import { capitalizeFirstLetter } from 'src/utils/string';
import getEditUrl from 'src/utils/item/getEditUrl';
import {
  getTipoEntidadeComentario,
  buildComentarioDialogTitle,
  extractPeriodoDescricao,
} from 'src/componentes/comentarios/utils';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';
import http from 'src/services/httpService';
import Info from 'src/componentes/info';
import {
  TIPO_ITENS,
  MODULOS,
  TIPO_ENTIDADE_PRINCIPAL_SOLICITACAO_GESTAO_MUDANCAS,
} from 'src/utils/constants';
import { manager } from 'src/services/cardMetaItemPermissions';
import ContextMenuIcon from 'src/componentes/context_menu_icon';

import ModalRelatorioAcompanhamento from '../relatorio-acompanhamento/modal';
import FichaObjetivoEstrategicoBase from '../objetivo-estrategico-base/ficha';
import FichaDesempenhoIndividual from '../remuneracao-variavel/desempenho-individual/ficha';
import FichaCalculoIntermediario from '../remuneracao-variavel/calculo-intermediario/ficha';
import ExportarRelatorioModal from '../relatorio-periodico/exportar-relatorio-modal';
import FichaIndicadorBase from '../indicador-base/ficha';
import FichaParametroBase from '../parametro-base/ficha';
import EmbedPowerBI from '../power-bi/componentes/power-bi-dialog';
import FichaProjeto from '../projeto/ficha';
import Mensagem from '../mensagem/modal';
import CurvaS from '../projeto/curvaS';
import history from '../../history';
import ProcessoEditView from 'src/paginas/gestao-risco/processo/edit';
import { acessarFrstClick } from 'src/componentes/AcessarFrstClick';
import { openComentarioModal } from 'src/componentes/comentarios/ComentarioButton';

let configuracaoCache = null;
let configuracaoPromise = null;
let permissoesExibicaoAbasPromise = null;
@autobind
class DropdownItemCustom extends React.Component {
  static defaultProps = {
    exibirEdicao: true,
    exibirFicha: true,
    exibirValor: true,
    exibirRelacionamento: true,
    exibirRelatorioAcompanhamento: true,
    exibirInteligenciaArtificial: false,
    exibirMensagem: true,
    exportResumo: false,
    exibirMatrizResultados: true,
    exibirPlanoAcao: true,
    labelAI: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      utilizarCurvaS: this.props.configuracoes?.utilizarCurvaS,
      permitirDigitacaoValores:
        this.props.configuracoes?.permitirDigitacaoValores,
    };
  }

  componentDidMount() {
    const { item } = this.props;

    if (item?.tipo?.id !== TIPO_ITENS.PROJETO) return;

    if (configuracaoCache) {
      this.setState(configuracaoCache);
      return;
    }

    if (!configuracaoPromise) {
      configuracaoPromise = http.post(
        `/ItemConfiguracao/ObterConfiguracaoValorProjeto`,
        {}
      );
    }

    configuracaoPromise.then((response) => {
      configuracaoCache = {
        utilizarCurvaS: response.data.utilizarCurvaS,
        permitirDigitacaoValores: response.data.permitirDigitacaoValores,
      };

      this.setState(configuracaoCache);
    });
  }

  getLabel(item) {
    const { renderLabel } = this.props;

    if (renderLabel) {
      return renderLabel;
    } else {
      return item.nome;
    }
  }

  handleExportClick(item) {
    const urlExportItem = this.getUrlItemExport(item);

    if (urlExportItem != null && item != null)
      http
        .post(
          urlExportItem,
          {
            id: item.id,
          },
          {
            responseType: 'arraybuffer',
          }
        )
        .then((response) => {
          DownloadFile(response);
        })
        .catch((error) => {
          errorHandler(ParseError(error));
        });
  }

  getUrlItemExport(item) {
    let urlExportItem = null;

    if (item.tipo && item.tipo.id == TIPO_ITENS.INDICADOR)
      urlExportItem = `/Indicador/ExportResumoIndicador`;
    else if (item.tipo && item.tipo.id == TIPO_ITENS.PROJETO)
      urlExportItem = `/Projeto/ExportResumoPlanoAcao`;

    return urlExportItem;
  }

  handleEditClick(item) {
    if (!item) return;

    const { callback, handleCloseModal, showModal } = this.props;

    if (showModal) {
      ContentManager.addContent(
        <this.props.editComponent
          {...this.props}
          item={item}
          handleClose={handleCloseModal}
          parameters={this.props.parameters}
        />
      );
    } else {
      const tipo = item.tipo && item.tipo?.id;
      const urlEdit = getEditUrl(tipo);

      history.push({
        pathname: `${urlEdit}`,
        search: `?id=${item.id}`,
      });
    }

    callback && callback();
    handleCloseModal && handleCloseModal();
  }

  obterFiltroUrl(item) {
    if (!item) return;

    const { filtro, visaoItensImpactados } = this.props;
    let url = `?itemId=${item.id}`;

    if (filtro != null && filtro != undefined) {
      url += `&openLastFilter=false`;

      // Tipo Filtro Data
      if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0)
        url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;

      // Visão Itens Impactados
      if (visaoItensImpactados) url += `&visaoItensImpactados=true`;

      // Data Inicio
      if (filtro.dataInicio != null) url += `&dataInicio=${filtro.dataInicio}`;

      // Data Termino
      if (filtro.dataTermino != null)
        url += `&dataTermino=${filtro.dataTermino}`;
    }

    return url;
  }

  obterFiltroUrlMatrizResultados(item) {
    let { filtro } = this.props;
    let url = '';

    if (item && item.exibirItensCardMetas) {
      let tipoItemCardMetas = item.tipoItemCardMetas;

      let searchParam =
        tipoItemCardMetas && tipoItemCardMetas.id == 1
          ? `&colaboradorCardMetasId=${item.user.id}&colaboradorCardMetasNome=${item.user.nome}`
          : item.area
          ? `&areaId=${item.area.id}&areaNome=${item.area.nome}`
          : '';

      url = '?exibirItensCardMetas=true';

      url += searchParam;

      if (filtro != null && filtro != undefined) {
        if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0) {
          url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;
          url += `&tipoFiltroDataDescricao=${filtro.tipoFiltroData.descricao}`;
        }

        if (filtro.dataInicio != null)
          url += `&dataInicio=${filtro.dataInicio}`;

        if (filtro.dataTermino != null)
          url += `&dataTermino=${filtro.dataTermino}`;
      }
    } else {
      // Filtra o Id do Item
      url = `?itemId=${item.id}`;

      if (filtro != null && filtro != undefined) {
        url += `&openLastFilter=false`;

        // Tipo Filtro Data
        if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0)
          url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;

        // Data Inicio
        if (filtro.dataInicio != null)
          url += `&dataInicio=${filtro.dataInicio}`;

        // Data Termino
        if (filtro.dataTermino != null)
          url += `&dataTermino=${filtro.dataTermino}`;
      }
    }

    return url;
  }

  handleValueClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/valor',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleRelatorioAcompanhamentoClick(item) {
    ContentManager.addContent(
      <ModalRelatorioAcompanhamento
        fromItem
        item={item}
        filtro={this.props.filtro}
      />
    );
    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handlePlanejamentoInicialClick(item) {
    ContentManager.addContent(
      <ModalPlanejamentoInicial
        fromItem
        item={item}
        filtro={this.props.filtro}
      />
    );
    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handlePlanoAcaoClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/gantt',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleMensagemClick(item) {
    ContentManager.addContent(<Mensagem fromItem item={{ id: item.id }} />);
    this.props.callback && this.props.callback();
  }

  handleComentarioClick(item) {
    if (!item || !item.id) return;

    const tipoId = item.tipo && item.tipo.id;
    const tipoEntidade = getTipoEntidadeComentario(tipoId);

    if (!tipoEntidade) return;

    const quantidadeComentarios =
      item.quantidadeComentarios != null ? item.quantidadeComentarios : 0;

    const { wrapper } = this.props;

    // Calcular datas do período acumulado do card de metas (do primeiro período até o último dia do último período)
    let dataInicio = null;
    let dataTermino = null;

    if (wrapper?.periodos?.length > 0) {
      // Filtrar períodos com data (excluir período 0 que é o acumulado) e ordenar
      const periodosComData = wrapper.periodos
        .filter((p) => p.periodo !== 0 && p.dataPeriodo)
        .sort((a, b) => a.ano - b.ano || a.periodo - b.periodo);

      if (periodosComData.length > 0) {
        dataInicio = periodosComData[0].dataPeriodo;

        const ultimo = new Date(
          periodosComData[periodosComData.length - 1].dataPeriodo
        );
        dataTermino = new Date(
          ultimo.getFullYear(),
          ultimo.getMonth() + 1,
          0,
          23,
          59,
          59
        );
      }
    }

    const dialogTitle = buildComentarioDialogTitle(
      this.props.intl,
      item?.nome,
      extractPeriodoDescricao(item)
    );

    let showTabs = false;
    if (this.props.fromCardMetas) {
      const isProjeto = item?.tipo?.id === TIPO_ITENS.PROJETO;
      if (isProjeto) {
        // Se Permitir digitação está habilitad, mostra itemvalor pra projeto
        showTabs = this.state.permitirDigitacaoValores === true;
      } else {
        // Para outros tipos de item, mostra tabs quando vem do card de metas
        showTabs = true;
      }
    }

    openComentarioModal({
      tipoEntidade,
      entidadeId: item.id,
      quantidadeComentarios,
      dialogTitle,
      onChangeQuantidade: (newCount) => {
        if (item) {
          item.quantidadeComentarios = newCount;
        }
      },
      item,
      modalProps: {
        showTabs,
        dataInicio,
        dataTermino,
      },
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleCurvaSClick(item) {
    ContentManager.addContent(<CurvaS id={item.id}></CurvaS>);
    this.props.callback && this.props.callback();
  }

  handleRelacionamentosClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/arvore',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleMatrizResultadosClick(item) {
    let url = this.obterFiltroUrlMatrizResultados(item);

    history.push({
      pathname: '/acompanhar/matriz-resultado',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleFichaClick(item) {
    const tipo = item.tipo && item.tipo.id;

    if (tipo === TIPO_ITENS.INDICADOR) {
      ContentManager.addContent(
        <FichaIndicadorBase
          id={item.id}
          obterDadosFichaUrl={`/Indicador/ObterDadosFicha`}
        ></FichaIndicadorBase>
      );
    } else if (tipo === TIPO_ITENS.PARAMETRO) {
      ContentManager.addContent(
        <FichaParametroBase
          id={item.id}
          obterDadosFichaUrl={`/Parametro/ObterDadosFicha`}
        ></FichaParametroBase>
      );
    } else if (tipo === TIPO_ITENS.OBJETIVO_ESTRATEGICO) {
      ContentManager.addContent(
        <FichaObjetivoEstrategicoBase
          id={item.id}
          obterDadosFichaUrl={`/ObjetivoEstrategico/ObterDadosFicha`}
        ></FichaObjetivoEstrategicoBase>
      );
    } else if (tipo === TIPO_ITENS.PROJETO) {
      ContentManager.addContent(<FichaProjeto id={item.id}></FichaProjeto>);
    } else if (tipo === TIPO_ITENS.CALCULO_INTERMEDIARIO) {
      ContentManager.addContent(
        <FichaCalculoIntermediario id={item.id}></FichaCalculoIntermediario>
      );
    } else if (tipo === TIPO_ITENS.DESEMPENHO_INDIVIDUAL) {
      ContentManager.addContent(
        <FichaDesempenhoIndividual id={item.id}></FichaDesempenhoIndividual>
      );
    } else if (tipo === TIPO_ITENS.TEMPLATE_INDICADOR) {
      ContentManager.addContent(
        <FichaIndicadorBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateIndicador/ObterDadosFicha`}
        ></FichaIndicadorBase>
      );
    } else if (tipo == TIPO_ITENS.TEMPLATE_PARAMETRO) {
      ContentManager.addContent(
        <FichaParametroBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateParametro/ObterDadosFicha`}
        ></FichaParametroBase>
      );
    } else if (tipo == TIPO_ITENS.TEMPLATE_OBJETIVO_ESTRATEGICO) {
      ContentManager.addContent(
        <FichaObjetivoEstrategicoBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateObjetivoEstrategico/ObterDadosFicha`}
        ></FichaObjetivoEstrategicoBase>
      );
    }

    this.props.callback && this.props.callback();
  }

  handleExportGrafico() {
    let {
      item,
      dataInicio,
      dataTermino,
      tipoFiltroData,
      exibirAcumulado,
      periodicidadeExibicao,
    } = this.props;

    const htmlGrafico =
      document.getElementById('htmlGrafico') &&
      document.getElementById('htmlGrafico').outerHTML;
    const htmlGraficoAnosAnteriores =
      document.getElementById('htmlGraficoAnosAnteriores') &&
      document.getElementById('htmlGraficoAnosAnteriores').outerHTML;
    const htmlGraficoValoresAcumuladosAno =
      document.getElementById('htmlGraficoValoresAcumuladosAno') &&
      document.getElementById('htmlGraficoValoresAcumuladosAno').outerHTML;

    //seleciona as medidas do gráfico de anos antriores para evitar problema com o zoom da tela
    const svgGraficoAnosAnteriores =
      document
        .getElementById('graficoValoresItem')
        ?.querySelectorAll('svg')[0] || null;
    const widthGraficoAnosAnteriores =
      (svgGraficoAnosAnteriores &&
        svgGraficoAnosAnteriores.getAttribute('width')) ||
      1190;
    const heightGraficoAnosAnteriores =
      (svgGraficoAnosAnteriores &&
        svgGraficoAnosAnteriores.getAttribute('height')) ||
      450;

    //seleciona as medidas do gráfico de valores para evitar problema com o zoom da tela
    const svgGraficoValores =
      document.getElementById('htmlGrafico')?.querySelectorAll('svg')[1] ||
      null;
    const widthGraficoValores =
      svgGraficoValores?.getAttribute('width') ||
      document.getElementById('htmlGrafico')?.scrollWidth ||
      1190;
    const heightGraficoValores =
      svgGraficoValores?.getAttribute('height') ||
      document.getElementById('htmlGrafico')?.scrollHeight ||
      450;

    //seleciona as medidas do gráfico acumulados do ano para evitar problema com o zoom da tela
    const svgsValoresAcumulados =
      document.getElementById('htmlGraficoValoresAcumuladosAno') &&
      document
        .getElementById('htmlGraficoValoresAcumuladosAno')
        .querySelectorAll('svg');
    const widthValoresAcumulados =
      (svgsValoresAcumulados &&
        svgsValoresAcumulados[0] &&
        svgsValoresAcumulados[0].getAttribute('width')) ||
      400;
    const heightValoresAcumulados =
      (svgsValoresAcumulados &&
        svgsValoresAcumulados[0] &&
        svgsValoresAcumulados[0].getAttribute('height')) ||
      450;

    this.setState({
      isLoading: true,
    });

    http
      .post(
        '/ItemValor/ExportarGraficoValores',
        {
          id: item.id,
          widthGraficoValores: widthGraficoValores,
          heightGraficoValores: heightGraficoValores,
          widthGraficoAnosAnteriores: widthGraficoAnosAnteriores,
          heightGraficoAnosAnteriores: heightGraficoAnosAnteriores,
          tipoFiltroData: tipoFiltroData,
          dataInicio: dataInicio,
          dataTermino: dataTermino,
          exibirAcumulado: exibirAcumulado,
          periodicidadeExibicao: periodicidadeExibicao
            ? periodicidadeExibicao
            : null,
          htmlGrafico: htmlGrafico,
          htmlGraficoAnosAnteriores: htmlGraficoAnosAnteriores,
          htmlGraficoValoresAcumuladosAno: htmlGraficoValoresAcumuladosAno,
          heightValoresAcumulados: heightValoresAcumulados,
          widthValoresAcumulados: widthValoresAcumulados,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        DownloadFile(response);

        this.setState({
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });

        errorHandler(ParseError(error));
      });
  }

  handleExport() {
    ContentManager.addContent(
      <ExportarRelatorioModal
        handleUrlCallBack={this.handleUrlCallBack}
        fileExtension="jpeg"
      />
    );
  }

  handleAnalytics(item) {
    window.open(item.analytics.uri, '_blank');
  }

  handleRelatorioBIClick(item) {
    http
      .post(`/PowerBI/ObterConfiguracoesPorIndicador`, {
        indicadorID: item.id,
      })
      .then((response) => {
        if (item.desdobramento) {
          response.data.model.campo = null;
        }
        ContentManager.addContent(
          <EmbedPowerBI
            itemId={item.id}
            relatorioPBI={response.data.model.relatorioPBI}
            embedURL={response.data.model.embedURL}
            workspacePBI={response.data.model.workspacePBI}
            filtros={response.data.model.filtros}
            embedToken={response.data.model.embedToken}
            usarAutenticacaoMicrosoft={
              response.data.model.usarAutenticacaoMicrosoft
            }
          />
        );
        this.setState({
          isLoading: false,
          resources: {},
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
        errorHandler(error);
      });

    this.props.callback && this.props.callback();
  }

  handleClickSophie(item) {
    this.props.handleClickSophieCallBack &&
      this.props.handleClickSophieCallBack(item);
  }

  handleStatusReport(item) {
    const filterUrl = `?id=${item.id}&activeTab=7`;
    const pathName = '/gerenciar/projeto/edit';
    history.push({
      pathname: pathName,
      search: filterUrl,
    });
    this.props.callback && this.props.callback();
  }

  handleResumoProjeto(item) {
    history.push(`/gerenciar/projeto/resumo?id=${item.id}`);
  }

  handleBacklogProjetoAgilClick(item) {
    history.push({
      pathname: '/gerenciar/projetos-ageis/edit',
      search: `?id=${item.id}&activeTab=2`,
    });
    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleSprintAtivaProjetoAgilClick(item) {
    history.push({
      pathname: '/gerenciar/projetos-ageis/edit',
      search: `?id=${item.id}&activeTab=3`,
    });
    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleDashboardProjetoAgilClick(item) {
    history.push({
      pathname: '/gerenciar/projetos-ageis/edit',
      search: `?id=${item.id}&activeTab=5`,
    });
    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  handleIndicadoresEParametrosProjetos(item) {
    history.push({
      pathname: '/gerenciar/projeto/edit',
      search: `?id=${item.id}&activeTab=9`,
    });
  }

  handleTermoAberturaProjetos(item) {
    history.push({
      pathname: '/gerenciar/projeto/edit',
      search: `?id=${item.id}&activeTab=10`,
    });
  }

  async getInternalTabGestaoMudancas(item) {
    if (!permissoesExibicaoAbasPromise) {
      permissoesExibicaoAbasPromise = http.post(
        'GestaoMudancas/ObterPermissoesExibicaoAbas',
        {}
      );
    }

    let showProjectsTab = false;
    try {
      const response = await permissoesExibicaoAbasPromise;
      showProjectsTab =
        !!response.data?.[
          TIPO_ENTIDADE_PRINCIPAL_SOLICITACAO_GESTAO_MUDANCAS.PROJETO
        ];
    } catch (error) {
      errorHandler(error);
      permissoesExibicaoAbasPromise = null;
    }

    if (item.tipo?.id === TIPO_ITENS.PROJETO) return 1;
    else if (item.tipo?.id === TIPO_ITENS.INDICADOR)
      return showProjectsTab ? 2 : 1;
    else if (item.tipo?.id === TIPO_ITENS.PARAMETRO)
      return showProjectsTab ? 3 : 2;
    else if (item.tipo?.id === TIPO_ITENS.OBJETIVO_ESTRATEGICO)
      return showProjectsTab ? 4 : 3;

    return showProjectsTab ? 2 : 1;
  }

  async handleRedirectGestaoMudancas(item) {
    const internalTab = await this.getInternalTabGestaoMudancas(item);
    history.push({
      pathname: '/minhas-tarefas/gestao-mudancas',
      search: `?tab=1&tabInterna=${internalTab}&isNew=true&entityId=${item.id}`,
    });
  }

  handleRedirectMatrizResponsabilidades(item) {
    history.push({
      pathname: '/acompanhar/matriz-responsabilidades',
      search: `?id=${item.id}`,
    });
  }

  handleClickContainer(callbackFn) {
    const item = this.props.item;

    if (this.props.fromCardMetas && item) {
      manager.grantCardMetasItemTemporaryPermission(item.id);
    }

    callbackFn();
  }

  handleEditClickProcesso(item) {
    ContentManager.addContent(
      <ProcessoEditView
        item={item}
        currenttabIndex={1}
        showDelete={true}
        handleClose={this.props.handleClose}
      />
    );
  }

  shouldDisplayStageGateField = (fieldsConfig, fieldId) => {
    const config = fieldsConfig.find(
      (c) => c.id.toString() === fieldId.toString()
    );
    return config?.utilizar === true;
  };

  render() {
    let {
      resources,
      item,
      exibirEdicao,
      exibirFicha,
      exibirValor,
      exibirRelacionamento,
      exibirRelatorioAcompanhamento,
      exibirMensagem,
      exportResumo,
      exportGrafico,
      exibirMatrizResultados,
      exibirInteligenciaArtificial,
      handleRelatorioBIClick,
      labelAI,
      tooltipAI,
      exibirPowerBI = true,
      intl,
      exibirPlanoAcao,
      configuracoes,
      ehEditar,
      modules,
      hideSummary = false,
      verificarPermissoes,
    } = this.props;

    const hasEPModule = modules.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    const { utilizarPlanejamentoInicial } = configuracoes || {};

    let utilizarGestaoMudancas = configuracoes
      ? configuracoes.utilizarGestaoMudancas
      : false;

    if (!utilizarGestaoMudancas && configuracoes) {
      if (
        item.tipo?.id === TIPO_ITENS.INDICADOR &&
        configuracoes.utilizarGestaoMudancasIndicador
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasIndicador;
      } else if (
        item.tipo?.id === TIPO_ITENS.PARAMETRO &&
        configuracoes.utilizarGestaoMudancasParametro
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasParametro;
      } else if (
        item.tipo?.id === TIPO_ITENS.OBJETIVO_ESTRATEGICO &&
        configuracoes.utilizarGestaoMudancasObjetivo
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasObjetivo;
      }
    }

    const exibirAnalytics =
      item &&
      item.analytics &&
      item.analytics.uri !== null &&
      item.analytics.uri !== '';

    const tipoId = item && item.tipo && item.tipo.id;
    const naoEhTemplate =
      tipoId !== TIPO_ITENS.TEMPLATE_INDICADOR &&
      tipoId !== TIPO_ITENS.TEMPLATE_PARAMETRO &&
      tipoId !== TIPO_ITENS.TEMPLATE_OBJETIVO_ESTRATEGICO &&
      tipoId !== TIPO_ITENS.TEMPLATE_PROJETO;

    if (tipoId === TIPO_ITENS.PROJETOS_AGEIS) {
      if (item && item.permissions && item.permissions.allowBasic) {
        exibirEdicao = false;
        exibirRelacionamento = false;
      }

      if (item && item.ocultarMenus) {
        return [];
      }

      return [
        exibirEdicao && (
          <DropdownItem key="1" style={{ minWidth: '18rem' }}>
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() => this.handleEditClick(item))
                }
              >
                <LucideIcon className="mr-2" icon="Pencil" />
                <FormattedMessage
                  id="label.editar"
                  values={{ editar: resources.editar }}
                />
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="editar"
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        ),
        exibirRelacionamento && (
          <DropdownItem key="4">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleRelacionamentosClick(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="Network" />
                {capitalizeFirstLetter(resources.relacionamentos)}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="relacionamentos"
                  obterFiltroUrl={this.obterFiltroUrl}
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        ),
        <DropdownItem key="backlog">
          <div className="tw:flex tw:w-full">
            <div
              style={{
                minWidth: '14rem',
                alignItems: 'center',
                display: 'flex',
              }}
              onClick={() =>
                this.handleClickContainer(() =>
                  this.handleBacklogProjetoAgilClick(item)
                )
              }
            >
              <LucideIcon className="mr-2" icon="ListTodo" />
              {capitalizeFirstLetter(intl.formatMessage({ id: 'backlog' }))}
            </div>
            <div className="ml-auto">
              <ContextMenuIcon
                item={item}
                origemClick="backlog"
                fromCardMetas={this.props.fromCardMetas}
              />
            </div>
          </div>
        </DropdownItem>,
        <DropdownItem key="sprintAtiva">
          <div className="tw:flex tw:w-full">
            <div
              style={{
                minWidth: '14rem',
                alignItems: 'center',
                display: 'flex',
              }}
              onClick={() =>
                this.handleClickContainer(() =>
                  this.handleSprintAtivaProjetoAgilClick(item)
                )
              }
            >
              <LucideIcon className="mr-2" icon="Play" />
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'sprintAtiva' })
              )}
            </div>
            <div className="ml-auto">
              <ContextMenuIcon
                item={item}
                origemClick="sprintAtiva"
                fromCardMetas={this.props.fromCardMetas}
              />
            </div>
          </div>
        </DropdownItem>,
        <DropdownItem key="dashboard">
          <div className="tw:flex tw:w-full">
            <div
              style={{
                minWidth: '14rem',
                alignItems: 'center',
                display: 'flex',
              }}
              onClick={() =>
                this.handleClickContainer(() =>
                  this.handleDashboardProjetoAgilClick(item)
                )
              }
            >
              <LucideIcon className="mr-2" icon="BarChart3" />
              {capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'dashboard' },
                  { dashboard: resources.dashboard }
                )
              )}
            </div>
            <div className="ml-auto">
              <ContextMenuIcon
                item={item}
                origemClick="dashboardProjetoAgil"
                fromCardMetas={this.props.fromCardMetas}
              />
            </div>
          </div>
        </DropdownItem>,
      ];
    }

    exibirPowerBI = exibirPowerBI
      ? item?.permissions
        ? item?.permissions?.allowViewPowerBI
        : true
      : false;

    const utilizarFrst =
      item && item.permissions && item.permissions.allowViewModuloFrst;

    let exibirPlanejamentoInicial =
      item && item.permissions && item.permissions.allowViewPlanejamentoInicial;
    let exibirCurvaS = false;
    let exibirStatusReport = false;
    let exibirResumoProjeto = false;
    let exibirIndicadoresParametrosETermoAberturaProjetos = false;
    let exibirGestaoMudancas = false;
    let exibirMatrizResponsabilidades = false;

    if (item && item.permissions && item.permissions.allowBasic) {
      exibirEdicao = false;
      exibirRelacionamento = false;
      exibirPlanoAcao = false;
      exibirMensagem = false;
    } else {
      if (tipoId == 6) {
        exibirMatrizResultados = false;
        exibirRelatorioAcompanhamento = false;
        exibirRelacionamento = true;
        exibirFicha = false;
        exibirValor = false;
      }

      if (tipoId == 5) {
        exibirRelatorioAcompanhamento = false;
        exibirRelacionamento = true;
        exibirFicha = false;
        exibirValor = false;
        exibirPlanoAcao = true;
        exibirMensagem = false;
        exibirMatrizResultados = false;
      }
    }

    if (tipoId == 1 || tipoId == 2 || tipoId == 3) {
      exibirGestaoMudancas =
        utilizarGestaoMudancas &&
        (!verificarPermissoes ||
          (item &&
            item.permissions &&
            item.permissions.allowViewGestaoMudancas));
    }

    if (tipoId == 4) {
      const ehProjetoEmAprovacao =
        item.status && (item.status.id == 6 || item.status.id == 7);

      const stageGate = item && item.stageGate;
      const stageGatefieldsConfig = stageGate && [
        ...(JSON.parse(item.etapaAtualStageGate?.camposEtapaJSON) || []),
        ...(JSON.parse(item.etapaAtualStageGate?.atributosEtapaJSON) || []),
      ];

      exibirFicha = !ehProjetoEmAprovacao;
      exibirRelacionamento = !ehProjetoEmAprovacao;
      exibirPlanoAcao = !ehProjetoEmAprovacao;
      exibirMensagem = !ehProjetoEmAprovacao;
      exibirMatrizResultados = false;
      exibirCurvaS = this.state.utilizarCurvaS && !ehProjetoEmAprovacao;
      exibirStatusReport = !ehEditar && !ehProjetoEmAprovacao;
      exibirResumoProjeto = !hideSummary && !ehProjetoEmAprovacao;
      exibirIndicadoresParametrosETermoAberturaProjetos =
        hasEPModule && hideSummary;
      exibirMatrizResponsabilidades = hasEPModule;
      exibirGestaoMudancas =
        hasEPModule &&
        utilizarGestaoMudancas &&
        item &&
        item.permissions &&
        item.permissions.allowViewGestaoMudancas;
      exibirValor = this.state.permitirDigitacaoValores;

      if (stageGate) {
        exibirPlanoAcao =
          exibirPlanoAcao &&
          this.shouldDisplayStageGateField(
            stageGatefieldsConfig,
            'planoDeAcao'
          );
        exibirMatrizResponsabilidades =
          exibirMatrizResponsabilidades &&
          this.shouldDisplayStageGateField(
            stageGatefieldsConfig,
            'matrizResponsabilidades'
          );
      }
    }

    if (
      tipoId == 12 ||
      tipoId == 13 ||
      tipoId == 14 ||
      tipoId == TIPO_ITENS.TEMPLATE_PROJETO
    ) {
      exibirRelacionamento = false;
      exibirMatrizResultados = false;
    }

    if (tipoId == TIPO_ITENS.TEMPLATE_PROJETO) {
      exibirPlanoAcao = true;
    }

    if (tipoId == 17) {
      exibirRelacionamento = false;
      exibirMatrizResultados = false;
      exibirPlanoAcao = false;
      exibirFicha = false;
      exibirMensagem = false;
    }

    if (item && item.ocultarMenus) {
      exibirEdicao = false;
      exibirFicha = false;
      exibirValor = false;
      exibirRelacionamento = false;
      exibirPlanoAcao = false;
      exibirRelatorioAcompanhamento = false;
      exibirMensagem = false;
      exportResumo = false;
      exibirMatrizResultados = false;
    }

    if (item && item.exibirItensCardMetas) {
      exibirEdicao = false;
      exibirFicha = false;
      exibirValor = false;
      exibirRelacionamento = false;
      exibirPlanoAcao = false;
      exibirRelatorioAcompanhamento = false;
      exibirMensagem = false;
      exportResumo = false;
      exibirMatrizResultados = true;
    }

    return [
      <>
        {exibirEdicao && (
          <DropdownItem key="1" style={{ minWidth: '18rem' }}>
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  tipoId === TIPO_ITENS.PROCESSO
                    ? this.handleClickContainer(() =>
                        this.handleEditClickProcesso(item)
                      )
                    : this.handleClickContainer(() =>
                        this.handleEditClick(item)
                      )
                }
              >
                <LucideIcon className="mr-2" icon="Pencil" />
                <FormattedMessage
                  id="label.editar"
                  values={{ editar: resources.editar }}
                />
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick={'editar'}
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      exibirFicha && naoEhTemplate && (
        <DropdownItem
          key="2"
          onClick={() =>
            this.handleClickContainer(() => this.handleFichaClick(item))
          }
        >
          <LucideIcon icon="Eye" />
          <FormattedMessage
            id="label.ficha"
            values={{ ficha: resources.ficha }}
          />
        </DropdownItem>
      ),

      <>
        {exibirResumoProjeto && (
          <DropdownItem key="16">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleResumoProjeto(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="FileText" />
                <FormattedMessage id="label.resumo" />
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="resumo"
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      exibirIndicadoresParametrosETermoAberturaProjetos && (
        <>
          <DropdownItem
            key="17"
            onClick={() =>
              this.handleClickContainer(() =>
                this.handleIndicadoresEParametrosProjetos(item)
              )
            }
          >
            <LucideIcon icon="BarChart3" />
            <FormattedMessage id="indicadoresEParametros" />
          </DropdownItem>
          <DropdownItem
            key="18"
            onClick={() =>
              this.handleClickContainer(() =>
                this.handleTermoAberturaProjetos(item)
              )
            }
          >
            <LucideIcon icon="BookOpen" />
            {capitalizeFirstLetter(resources.tap)}
          </DropdownItem>
        </>
      ),

      <>
        {exibirValor && naoEhTemplate && (
          <DropdownItem key="3">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() => this.handleValueClick(item))
                }
              >
                <LucideIcon className="mr-2" icon="ListOrdered" />
                {capitalizeFirstLetter(resources.valores)}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="valores"
                  obterFiltroUrl={this.obterFiltroUrl}
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      <>
        {exibirRelacionamento && (
          <DropdownItem key="4">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleRelacionamentosClick(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="Network" />
                {capitalizeFirstLetter(resources.relacionamentos)}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="relacionamentos"
                  obterFiltroUrl={this.obterFiltroUrl}
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      <>
        {exibirMatrizResultados && (
          <DropdownItem key="5">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleMatrizResultadosClick(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="Table" />
                {capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'matrizderesultados' },
                    { matrizderesultados: resources.matrizderesultados }
                  )
                )}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="matrizResultados"
                  obterFiltroUrlMatrizResultados={
                    this.obterFiltroUrlMatrizResultados
                  }
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      <>
        {exibirPlanoAcao &&
          tipoId !== 2 &&
          (naoEhTemplate || tipoId == TIPO_ITENS.TEMPLATE_PROJETO) && (
            <DropdownItem key="6">
              <div className="tw:flex tw:w-full">
                <div
                  style={{
                    minWidth: '14rem',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                  onClick={() =>
                    this.handleClickContainer(() =>
                      this.handlePlanoAcaoClick(item)
                    )
                  }
                >
                  <LucideIcon className="mr-2" icon="ChartNoAxesGantt" />
                  {capitalizeFirstLetter(resources.planodeacao)}
                </div>
                <div className="ml-auto">
                  <ContextMenuIcon
                    item={item}
                    origemClick="planoAcao"
                    obterFiltroUrl={this.obterFiltroUrl}
                    fromCardMetas={this.props.fromCardMetas}
                  />
                </div>
              </div>
            </DropdownItem>
          )}
      </>,

      <>
        {exibirGestaoMudancas && (
          <DropdownItem key="19">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleRedirectGestaoMudancas(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="RefreshCw" />
                {intl.formatMessage(
                  { id: 'gestaoMudancas' },
                  { gestaoMudancas: resources.gestaoMudancas }
                )}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="gestaoMudancas"
                  getInternalTabGestaoMudancas={
                    this.getInternalTabGestaoMudancas
                  }
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      <>
        {exibirMatrizResponsabilidades && (
          <DropdownItem key="20">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() =>
                    this.handleRedirectMatrizResponsabilidades(item)
                  )
                }
              >
                <LucideIcon className="mr-2" icon="Table" />
                {intl.formatMessage({ id: 'matrizResponsabilidades' })}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="matrizResponsabilidades"
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      exibirCurvaS && (
        <DropdownItem
          key="7"
          onClick={() =>
            this.handleClickContainer(() => this.handleCurvaSClick(item))
          }
        >
          <LucideIcon icon="LineChart" />
          <FormattedMessage id="curvaS" />
        </DropdownItem>
      ),

      exibirRelatorioAcompanhamento &&
        (tipoId === 1 || tipoId === 3) &&
        naoEhTemplate && (
          <DropdownItem
            key="8"
            onClick={() =>
              this.handleClickContainer(() =>
                this.handleRelatorioAcompanhamentoClick(item)
              )
            }
          >
            <LucideIcon icon="ClipboardList" />
            {capitalizeFirstLetter(resources.relatoriodeacompanhamento)}
          </DropdownItem>
        ),

      utilizarPlanejamentoInicial &&
        exibirPlanejamentoInicial &&
        naoEhTemplate && (
          <DropdownItem
            key="9"
            onClick={() =>
              this.handleClickContainer(() =>
                this.handlePlanejamentoInicialClick(item)
              )
            }
          >
            <LucideIcon icon="Files" />
            <FormattedMessage id="planejamentoInicial" />
          </DropdownItem>
        ),

      exibirMensagem && naoEhTemplate && (
        <DropdownItem
          key="10"
          onClick={() =>
            this.handleClickContainer(() => this.handleMensagemClick(item))
          }
        >
          <LucideIcon icon="MessageSquareText" />
          <FormattedMessage id="label.mensagens" />
        </DropdownItem>
      ),

      exportResumo && naoEhTemplate && (
        <DropdownItem
          key="11"
          onClick={() =>
            this.handleClickContainer(() => this.handleExportClick(item))
          }
        >
          <LucideIcon icon="FileText" />
          <FormattedMessage id="label.exportarPDF" />{' '}
          <Info
            id="exportPDF"
            placement="right"
            text={<FormattedMessage id="exportResumo" />}
          />
        </DropdownItem>
      ),

      exportGrafico && naoEhTemplate && (
        <DropdownItem
          key="12"
          onClick={() =>
            this.handleClickContainer(() => this.handleExportGrafico(item))
          }
        >
          <LucideIcon icon="FileSpreadsheet" />
          <FormattedMessage id="exportarGrafico" />{' '}
        </DropdownItem>
      ),

      exibirPowerBI && naoEhTemplate && (
        <DropdownItem
          key="13"
          onClick={() =>
            this.handleClickContainer(() =>
              handleRelatorioBIClick
                ? handleRelatorioBIClick(item)
                : this.handleRelatorioBIClick(item)
            )
          }
        >
          <LucideIcon icon="Clipboard" />
          <FormattedMessage id="bi" />
        </DropdownItem>
      ),

      item && getTipoEntidadeComentario(tipoId) && this.props.fromCardMetas && (
        <DropdownItem
          key="22"
          onClick={() =>
            this.handleClickContainer(() => this.handleComentarioClick(item))
          }
        >
          <LucideIcon icon="MessageSquareText" />
          <FormattedMessage id="label.comentarios" />
        </DropdownItem>
      ),

      exibirAnalytics && (
        <DropdownItem
          key="14"
          onClick={() =>
            this.handleClickContainer(() => this.handleAnalytics(item))
          }
        >
          <LucideIcon icon="Clipboard" />
          <FormattedMessage id="Analytics" />
        </DropdownItem>
      ),

      <>
        {exibirStatusReport && (
          <DropdownItem key="15">
            <div className="tw:flex tw:w-full">
              <div
                style={{
                  minWidth: '14rem',
                  alignItems: 'center',
                  display: 'flex',
                }}
                onClick={() =>
                  this.handleClickContainer(() => this.handleStatusReport(item))
                }
              >
                <LucideIcon className="mr-2" icon="FileText" />
                {capitalizeFirstLetter(resources.statusreport)}
              </div>
              <div className="ml-auto">
                <ContextMenuIcon
                  item={item}
                  origemClick="statusReport"
                  fromCardMetas={this.props.fromCardMetas}
                />
              </div>
            </div>
          </DropdownItem>
        )}
      </>,

      exibirInteligenciaArtificial && naoEhTemplate && (
        <Tooltip key="16" text={tooltipAI}>
          <DropdownItem
            onClick={() =>
              this.handleClickContainer(() => this.handleClickSophie(item))
            }
          >
            <LucideIcon icon="Zap" />
            {labelAI}
          </DropdownItem>
        </Tooltip>
      ),

      utilizarFrst && naoEhTemplate && (
        <DropdownItem
          key="21"
          onClick={() =>
            this.handleClickContainer(() => acessarFrstClick(this.props.intl))
          }
        >
          <LucideIcon icon="Monitor" />
          FRST
        </DropdownItem>
      ),
    ];
  }
}

function mapStateToProps(state) {
  return {
    modules: state.user.licenca.modulos,
  };
}

export default injectIntl(connect(mapStateToProps)(DropdownItemCustom));
